export const dashboard: Dashboard = {
    rowHeight: 175,
    editable: true,
    columns: {
        'xxs': 1,
        'xs': 2,
        'sm': 3,
        'md': 4,
        'lg': 4,
    },
    widgets: [{
        module: 'processes',
        name: 'general.tableStatus',
        label: 'processes.tableIndex',
        x: 0,
        y: 1,
        height: 2,
        props: {
            module: 'processes',
            detail: 'service-processes-id-processBaseData',
            title: 'dashboard.widgets.processes.title',
            nameProp: 'process_number',
            infoProp: 'fundingProgram.name',
            statusProp: 'status',
            filter: [{
                name: 'status',
                relation: 'status',
                column: 'statuses.key',
                operator: 'in',
                value: ['a_started', 'a_started_digital', 'v_started', 'v_started_digital']
            }]
        }
    }, {
        module: 'paymentRuns',
        name: 'general.tableStatus',
        label: 'paymentRuns.tableIndex',
        x: 0,
        y: 1,
        height: 2,
        props: {
            module: 'paymentRuns',
            detail: 'service-payments-paymentRuns-id-paymentRunBaseData',
            title: 'dashboard.widgets.paymentRuns.title',
            namePre: 'dashboard.widgets.paymentRuns.id',
            nameProp: 'id',
            infoProp: 'intended_use',
            detailProp: 'sum',
            filter: [{
                name: 'created',
                column: 'customFilterRecent',
                operator: '>',
                value: '14'
            }]
        }
    }],
}